import { ChargeFeeTariffPeriod } from "@/models/chargeFeeTariffPeriod";

export const ContractFeeConstants = {
  ContractFee: "契約料金",
  AdjustCostUnitPriceParKw: "調整費単価（円/kWh/台月）",
  ChargeServiceCostUnitPriceParKw: "チャージサービス単価（円/kWh/台月）",
  TargetMonth: "対象年月",
  MinChargeAmount: "最低充電量（kWh/台月）",
  AmountOfUsage: "利用電力量",
  UnitPrice: "単価（円/kWh）",
  Month: "年月",
  Message1: "※上記はEV1台あたりの利用料及び最低充電量となります",
  Message2:
    "※その他利用料の算出及び請求方法に関しては電力サービスに関する利用規約の通りです",
} as const;

export const taxMessageOf = (period?: ChargeFeeTariffPeriod) => {
  if (period == null) {
    return "";
  }

  return `※以下に記載の単価はすべて${
    period.isTaxExcluded ? "税抜" : "税込"
  }となります`;
};
